module.exports = __webpack_public_path__ + "img/fusion-logo.b67a0f69.svg";